import { useEffect, useState } from "react";

import { useInspectionsList } from "data/ss-data-hooks";
import { type KeystoneInspection } from "utils/keystone-api-mapping";

export const useInspectionsData = () => {
  const { error, isLoading, data: inspectionsData } = useInspectionsList();
  const [latestInspection, setLatestInspection] =
    useState<KeystoneInspection>();

  // inspectionWriteOutDueDate should be non-null only for policies that are pending
  // cancellation - use it for the inspection due date if it exists.
  const inspectionDueDate =
    inspectionsData?.inspectionWriteOutDueDate ??
    inspectionsData?.inspectionDeadline;

  // Use latest inspection:
  useEffect(() => {
    if (inspectionsData?.inspections) {
      const latest = inspectionsData?.inspections.sort(
        (a, b) =>
          new Date(b.createdTimestamp).getTime() -
          new Date(a.createdTimestamp).getTime()
      )[0];

      if (latest) {
        setLatestInspection(latest);
      }
    }
  }, [inspectionsData?.inspections]);

  return { error, isLoading, latestInspection, inspectionDueDate };
};
